import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableFooter from "@mui/material/TableFooter";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

export default function TeamTable({ stats }) {
  const rows = stats.sort(
    (a, b) =>
      b.created + b.sent + b.viewed + (b.share_links || 0) -
      (a.created + a.sent + a.viewed + (a.share_links || 0))
  );

  const totals = rows.reduce(
    (acc, row) => ({
      created: acc.created + (row.created || 0),
      sent: acc.sent + (row.sent || 0),
      share_links: acc.share_links + (row.share_links || 0),
      viewed: acc.viewed + (row.viewed || 0),
    }),
    { created: 0, sent: 0, share_links: 0, viewed: 0 }
  );

  return (
    <TableContainer>
      <Table aria-label="team stats table">
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 600 }}>Name</TableCell>
            <TableCell align="right" sx={{ fontWeight: 600 }}>Created</TableCell>
            <TableCell align="right" sx={{ fontWeight: 600 }}>Sent</TableCell>
            <TableCell align="right" sx={{ fontWeight: 600 }}>Links shared</TableCell>
            <TableCell align="right" sx={{ fontWeight: 600 }}>Viewed</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.name} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell align="right">{row.created}</TableCell>
              <TableCell align="right">{row.sent}</TableCell>
              <TableCell align="right">{row.share_links || 0}</TableCell>
              <TableCell align="right">{row.viewed}</TableCell>
            </TableRow>
          ))}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TableCell sx={{ fontWeight: 600, color: "text.primary" }}>
              Total
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600, color: "text.primary" }}>
              {totals.created}
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600, color: "text.primary" }}>
              {totals.sent}
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600, color: "text.primary" }}>
              {totals.share_links}
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600, color: "text.primary" }}>
              {totals.viewed}
            </TableCell>
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
}